// extracted by mini-css-extract-plugin
module.exports = {"button":"euroseeds-module--button--3cHXF","icon":"euroseeds-module--icon--180q2","content":"euroseeds-module--content--2MZAS","container":"euroseeds-module--container--VvjFi"};